import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CanDeactivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { ContractPagesComponent } from '../pages/secure/contract-pages/contract-pages.component';

@Injectable()
export class CanDeactivateContractGuard implements CanDeactivate<ContractPagesComponent> {
  canDeactivate(
    component: ContractPagesComponent,
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot,
    nextState?: RouterStateSnapshot
  ): Observable<boolean> | boolean {
    if (component.pendingSave && component.pendingChangesModal && nextState) {
      component.pendingChangesModal.openModal(nextState.url);
      return false;
    } else return true;
  }
}
